/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Code_BlockInputs */

const en_common_editor_code_block = /** @type {(inputs: Common_Editor_Code_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code block`)
};

const zh_common_editor_code_block = /** @type {(inputs: Common_Editor_Code_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代码块`)
};

/**
* | output |
* | --- |
* | "Code block" |
*
* @param {Common_Editor_Code_BlockInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_code_block = /** @type {((inputs?: Common_Editor_Code_BlockInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Code_BlockInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_code_block(inputs)
	return zh_common_editor_code_block(inputs)
});
export { common_editor_code_block as "common.editor.code_block" }